import { ReactNode } from 'react';
import { FiFileText, FiSettings, FiUser, FiUsers } from 'react-icons/fi';
import { PATHS } from './paths';

export const isActive = (href: string) => {
  return window.location.pathname === href;
};
export type UserRole = 'ADMIN' | 'FOREMAN';
type MenuType = {
  title: string;
  icon: ReactNode;
  subMenu?: { title: string; href: string }[];
  href?: string;
  permissions: UserRole[];
};

export const SidebarMenu: MenuType[] = [
  {
    title: 'MANAGE TIMESHEETS',
    icon: <FiFileText />,
    href: PATHS.homeTimesheet,
    permissions: ['ADMIN', 'FOREMAN'],
  },
  {
    title: 'MANAGE EMPLOYEES',
    icon: <FiUser />,
    href: PATHS.homeEmployee,
    permissions: ['ADMIN'],
  },
  {
    title: 'MANAGE USERS',
    icon: <FiUsers />,
    href: PATHS.homeUser,
    permissions: ['ADMIN'],
  },
  {
    title: 'MANAGE TABLES',
    icon: <FiSettings />,
    permissions: ['ADMIN'],
    subMenu: [
      { title: 'MANAGE JOB NUMBERS', href: PATHS.homeJobCodes },
      { title: 'MANAGE PHASE CODES', href: PATHS.homePhaseCodes },
      { title: 'MANAGE TASKS', href: PATHS.homeTasks },
    ],
  },
];
